import { FormInstance } from "antd"
import { Dispatch, MutableRefObject, SetStateAction, createContext } from "react"
import { IFormService } from "../ApplicationCfg"
import { BackendService } from "@dto/backendResponse.dto"

interface IApplicationContext {
  openAdvancedModal: boolean
  setOpenAdvancedModal: Dispatch<SetStateAction<boolean>>
  tabValue: string
  formAdvanced: FormInstance<IFormService>
  isLoadingVariables: boolean
  setIsLoadingVariables: Dispatch<SetStateAction<boolean>>
  microservice: string
  setMicroservice: Dispatch<SetStateAction<string>>
  keysOfValues: string[]
  setKeysOfValues: Dispatch<SetStateAction<string[]>>
  services: BackendService[]
  setServices: Dispatch<SetStateAction<BackendService[]>>
  originalItemsRef: MutableRefObject<Map<string, { key: string; value: string }>>
}

export const ApplicationContext = createContext<IApplicationContext>(null)
